import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { useLang } from "@/context/LangContext";
import useSiteMeta from "@/hooks/useSiteMeta";

import PageLoader from "@/components/ui/PageLoader";
import ScrollToTop from "@/components/ui/ScrollToTop";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Portfolio from "@/components/sections/Portfolio";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Stats from "@/components/sections/Stats";
import About from "@/components/sections/About";
import BoldStatement from "@/components/sections/BoldStatement";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";

import useLenis from "@/hooks/useLenis";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function HomePage() {
  const { lang } = useLang();
  useSiteMeta(lang);
  useLenis();
  useScrollReveal();

  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <PageLoader />
      <div className="bg-navy-deep text-white-warm min-h-screen" style={{ overflowX: "clip" }}>
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Portfolio />
          <Services />
          <Process />
          <Stats />
          <About />
          <BoldStatement />
          <Testimonials />
          <Pricing />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <ScrollToTop />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(16,15,12,0.95)",
              color: "#F2E8D8",
              border: "1px solid rgba(200,121,65,0.25)",
              fontFamily: '"Outfit", sans-serif',
              fontSize: "13px",
            },
          }}
        />
      </div>
    </MotionConfig>
  );
}